<template>
	<div class="login_box">
		<div class="p_flex p_box ">
			<div class="one_left">
				<div class="one_left-tiw"><img  src="../../assets/img/Boss_Two Color.png" /></div>
			</div>
			<div class="one_two">
				<div class="two_log"><img  src="../../assets/img/1.9_透明底.png" /></div>
				<div class="p_m_t_a">
					<div class="two_com" @click="goLogin(0)"><el-button type="success">我是老师</el-button></div>
				</div>
				<div class="p_m_t_b">
					<div class="two_com"><el-button type="success" @click="goLogin(1)">我是学生</el-button></div>
				</div>
			</div>
		</div>
		<div class="footer"><a href="javascript:" onClick="window.open('http://beian.miit.gov.cn/')">滇ICP备2021007786号</a></div>
	</div>
</template>

<script>
export default {
	name: 'LoginOne',
	methods: {
		goLogin(id) {
			localStorage.setItem('userInfo', id);
			this.$router.push({
				path: 'Login',
				query: {
					id: id
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.one_left {
	width: 50%;
	background-color: #fafafa;
	border-radius: 20px 0px 0px 20px;
}
.one_left .one_left-tiw {
	width: 80%;
	margin: 15% auto 0;
}
.one_two {
	 width: 50%;
	background: #ffffff;
	border-radius: 0px 20px 20px 0px;
}

.p_m_t_a{
	margin-top: 20%;
}

.p_m_t_b{
	margin-top: 15%;
}

.two_com {
	width: 50%;
	margin: 0 auto;
}

.two_log {
	width: 40%;
	margin: 10% auto 0;
	// background: #0000FE;
	// margin: 100px auto 0;
}

.el-button--success {
	width: 100%;
	margin: 0 auto;
}
.el-button {
	border-radius: 20px;
	font-size: 22px;
	padding: 20px;
}
.footer {
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}
.login_box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 60%;
	height: 85%;
}
img {
	width: 100%;
	height: auto;
	object-fit: cover;
}
.p_box{
	width: 100%;
	height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/login/loginOne.vue